// import { useState } from "react";
// import { Box, Text, useToast } from "native-base";
// import { COLORS } from "../../utils/colors";

// export const Toaster = () => {
//   const toast = useToast();
//   const [isActive, setIsActive] = useState(false);

//   const toaster = (message, type, id) => {
//     if (!isActive) {
//       setIsActive(true);
//       toast.show({
//         render: () => {
//           return (
//             <Box
//               bg={
//                 type === "success"
//                   ? COLORS.SUCCESS_TOAST_COLOR
//                   : COLORS.ERROR_TOAST_COLOR
//               }
//               px="2"
//               py="1"
//               rounded="sm"
//               mb={5}
//               height="50px"
//             >
//               <Text mt={2} fontSize={16} color={COLORS.WHITE_COLOR}>
//                 {message}
//               </Text>
//             </Box>
//           );
//         },
//         duration: 3000,
//         placement: "top",
//         zIndex: 9999,
//         onCloseComplete: () => {
//           setIsActive(false);
//         },
//       });
//     }
//   };

//   return toaster;
// };

import React, { useState } from "react";
import { Box, Text, useToast } from "native-base";
import { COLORS } from "../../utils/colors";

export const Toaster = () => {
  const toast = useToast();
  const [active, setActive] = useState({ error: false, success: false });

  const showToast = (message, type) => {
    const typeActive = active[type];
    if (!typeActive) {
      setActive({ ...active, [type]: true });
      toast.show({
        render: () => (
          <Box
            bg={type === "error" ? COLORS.ERROR_TOAST_COLOR : COLORS.SUCCESS_TOAST_COLOR}
            px="2"
            py="1"
            rounded="sm"
            mb={5}
            height="50px"
          >
            <Text mt={2} fontSize={16} color={COLORS.WHITE_COLOR}>
              {message}
            </Text>
          </Box>
        ),
        duration: 3000,
        placement: "top",
        zIndex: 9999,
        onCloseComplete: () => setActive({ ...active, [type]: false }),
      });
    }
  };

  return showToast;
};
